export const USER_LIST_ATTRIBUTES_CONSTANT = {
  partner: {
    type: 'select',
    key: 'partner_id',
    label: 'Partner',
  },
  search: {
    type: 'text',
    key: 'search',
    label: 'Search',
    placeholder: 'name/email',
  },
  role: {
    type: 'select',
    key: 'role',
    label: 'Role',
  },
} as const;
